export type PassRateFilterOption = "bottom10" | "top10" | "all"

// Applies a bottom10/top10/all filter to a pre-sorted (ascending passRate) array.
// bottom10: worst 10 pass rates (first in sorted array)
// top10: best 10 pass rates (last in sorted array, reversed for display)
// all: full array unchanged
export function applyPassRateFilter<T>(data: T[], filter: PassRateFilterOption): T[] {
  if (filter === "bottom10") return data.slice(0, 10)
  if (filter === "top10") return [...data].reverse().slice(0, 10)
  return data
}
